interface EquifaxFraudIqCheck {
    alerts: string[]
}

interface EquifaxDigitalIdentityTrustEvaluation {
    verified: boolean;
    matched: boolean;
    trusted: boolean;
}

export interface EquifaxDigitalIdentityTrustCheck {
    decision: "DENY"|"REVIEW"|"APPROVE";

    identity: EquifaxDigitalIdentityTrustEvaluation;
    phone: EquifaxDigitalIdentityTrustEvaluation;
    email: EquifaxDigitalIdentityTrustEvaluation;
    address: EquifaxDigitalIdentityTrustEvaluation;
    ssn: EquifaxDigitalIdentityTrustEvaluation;
    dob: EquifaxDigitalIdentityTrustEvaluation;
}

export interface Checks {
    equifaxFraudIq?: EquifaxFraudIqCheck
    equifaxDigitalIdentityTrust?: EquifaxDigitalIdentityTrustCheck
}